
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import moment from "moment";


import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)


// ------ Firebase Config ------
import firebase from 'firebase/app'
import 'firebase/firestore'

firebase.initializeApp({
    apiKey: "AIzaSyA-9kHXZpRSuIlO_JM2OrYQHTP0qpAQbdg",
    authDomain: "visity-usa.firebaseapp.com",
    databaseURL: "https://visity-usa.firebaseio.com", 
    projectId: "visity-usa",
    storageBucket: "visity-usa.appspot.com",
    messagingSenderId: "405206401448",
    appId: "1:405206401448:web:8a78422a9c92a5650d1d9d",
    measurementId: "G-T32CJXZXL4"
})

export const db = firebase.firestore()

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("D MMM YYYY | HH:mm");
  }
});

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("D MMM YYYY");
  }
});

Vue.filter("formatTime", function(value) {
  if (value) {
    return moment(String(value)).format("HH:mm");
  }
});

export const globalStore = new Vue({
  data: {
    AdminId: '',
    AdminName: '',
    AdminEmail: '',
    Menu: '',
    Feedback: '',
    Marketing: '',
    UserInfo: {}
  }
});

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
